import React, { Component } from "react";
import { Dialog } from "@vitalsource/vstui";
import OnboardingImage from "./onboarding-image";
import styled from "styled-components";
import { styledMedia } from "../../../ui/components/mediaquery/breakpoints";

const AlteredDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${styledMedia.medium`
    display: none;
  `}
`;

class NewReaderOnboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  componentDidMount() {
    const userObj = Fraction.Helpers.getDataObject("User.Persist");
    if (!Fraction.Brand.ReaderOnboarding.enabled) {
      return;
    }
    if (userObj.NewReaderOnboarding) {
      if (userObj.NewReaderOnboarding >= 3) {
        return;
      } else {
        userObj.NewReaderOnboarding += 1;
      }
    } else userObj.NewReaderOnboarding = 1;
    Fraction.Helpers.savePersist();
    this.timeout = setTimeout(() => {
      this.setState({ open: true });
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  shouldShowCustomOnboarding() {
    const customOnboardingEnabled =
      Fraction.Brand.ReaderOnboarding.custom.enabled;
    if (customOnboardingEnabled) {
      return true;
    }
    return false;
  }

  render() {
    if (!this.shouldShowCustomOnboarding()) {
      return (
        <AlteredDialog
          title={i18n.t("onboarding.new-reader.title")}
          open={this.state.open}
          onRequestClose={() => this.setState({ open: false })}
          customSize={400}
        >
          <OnboardingImage />
          {i18n.t("onboarding.new-reader.description", {
            name: Fraction.Brand.name
          })}
        </AlteredDialog>
      );
    } else
      return (
        <AlteredDialog
          title={Fraction.Brand.ReaderOnboarding.custom.title}
          open={this.state.open}
          onRequestClose={() => this.setState({ open: false })}
          customSize={400}
        >
          {Fraction.Brand.ReaderOnboarding.custom.image ? (
            <img
              src={Fraction.Brand.ReaderOnboarding.custom.image}
              alt={Fraction.Brand.ReaderOnboarding.custom.title}
            />
          ) : (
            <OnboardingImage />
          )}
          {Fraction.Brand.ReaderOnboarding.custom.description}
        </AlteredDialog>
      );
  }
}

module.exports = NewReaderOnboarding;
